/* eslint-disable no-useless-escape */
import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import FocusLock from "react-focus-lock";

import BaseButton from "../Button/BaseButton";
import { IconClose16 } from "../Icons/Icons";

import "./video.scss";

export const getVideoPath = url => {
  url.match(
    /(http|https):\/\/(player.|www.|play.)?(webvideocore.net|vimeo\.com|youtu(be\.com|\.be))\/(video\/|embed\/|watch\?v=)?([A-Za-z0-9._%-]*)(\&\S+)?/
  );

  const match = {
    provider: null,
    url: RegExp.$3,
    id: RegExp.$6,
    embedHTML: null,
  };

  if (match.url === "youtube.com" || match.url === "youtu.be") {
    return `https://www.youtube.com/embed/${match.id}`;
  }

  if (match.url === "vimeo.com") {
    return `https://player.vimeo.com/video/${match.id}`;
  }

  if (match.url === "webvideocore.net") {
    return url;
  }

  return false;
};

const isHtml5Video = url => {
  return url.match(/(.*?)\.(mp4|webm|ogg)$/i);
};

class Video extends Component {
  constructor(props) {
    super(props);

    this.handleOnEscape = this.handleOnEscape.bind(this);
    this.renderVideoFrame = this.renderVideoFrame.bind(this);
    this.renderVideoModal = this.renderVideoModal.bind(this);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleOnEscape, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleOnEscape);
  }

  handleOnEscape(e) {
    const { inModal, handleCloseModal } = this.props;
    if (inModal && e.keyCode === 27) {
      handleCloseModal(e);
    }
  }

  renderVideo = () => {
    const { url, supportMessage, inModal, showModal, captionUrl } = this.props;
    const videoUrl = getVideoPath(url);
    const html5VideoUrl = isHtml5Video(url);

    if (videoUrl) {
      return (
        <iframe
          className="video-player__frame"
          src={`${videoUrl}${inModal && showModal ? "?autoplay=1" : ""}`}
          frameBorder="0"
          allowFullScreen
          title="video"
        />
      );
    }

    if (html5VideoUrl) {
      return (
        <video controls>
          <source src={url} title="video" className="video-player__frame" />
          <track src={captionUrl} kind="captions" />
        </video>
      );
    }

    return <p className="video-player__support-message">{supportMessage}</p>;
  };

  renderVideoFrame() {
    const { id, className } = this.props;

    const classes = classNames(
      "video-player",
      "responsive-embed",
      "u-bg-grey-accessible",
      className
    );

    return (
      <div className={classes} id={id}>
        {this.renderVideo()}
      </div>
    );
  }

  renderVideoModal() {
    const { showModal, handleCloseModal } = this.props;
    if (showModal) {
      return (
        <FocusLock returnFocus>
          <div className="video-stage" role="presentation" aria-hidden={!showModal}>
            <BaseButton
              onClick={e => {
                handleCloseModal(e);
              }}
              className="video-stage__close"
            >
              <IconClose16 className="video-stage__close-icon" />
            </BaseButton>
            <div id="video-stage-content" className="video-stage__inner">
              {showModal ? this.renderVideoFrame() : null}
            </div>
          </div>
        </FocusLock>
      );
    }
    return null;
  }

  render() {
    const { inModal } = this.props;
    return inModal ? this.renderVideoModal() : this.renderVideoFrame();
  }
}

Video.propTypes = {
  id: PropTypes.string,
  url: PropTypes.string.isRequired,
  captionUrl: PropTypes.string,
  inModal: PropTypes.bool,
  showModal: PropTypes.bool,
  handleCloseModal: PropTypes.func,
  supportMessage: PropTypes.string,
  className: PropTypes.string,
};

export default Video;
